import React from "react";

import "./index.scss";

import BackCloseButton from "components/BackCloseButton";

const Video = () => {
  return (
    <div className="video-page page">
      <BackCloseButton navigationPath="/home" closeIcon />
      <video
        className="video-element"
        src={require("assets/video/home/screensaver.mp4")}
        poster={require("assets/video/home/poster/screensaver.webp")}
        autoPlay
        loop
      />
    </div>
  );
};

export default Video;
